import { AsyncComponent } from '@frontend/components/common';
import { Application, Feature, Functionality } from '@frontend/functionality/types';
import { lazy } from 'react';
import { Route } from 'react-router-dom';

import { ApplicationBundleUsageLayout } from '../../components/application-bundle-usage-layout/application-bundle-usage-layout.component';
import { checkFeatureRoute, checkLicenseRoutes } from '../utils';
import { Coffins } from './coffins/coffins.component';
import NivalizDashboard from './dashboard/dashboard.component';
import { NivalizTransactions } from './transactions/transactions.component';
import { Urns } from './urns/urns.component';

const NivalizDeceaseds = lazy(() => import('./deceaseds/deceaseds.component'));

export function ApplicationsNivalizRoutes(functionalities: Functionality[] | null) {
    const routeLicenseCheckResult = functionalities !== null ? checkLicenseRoutes(functionalities, Application.NIVALIZ) : null;

    if (routeLicenseCheckResult && !routeLicenseCheckResult.appEnabled) {
        return null;
    }

    return (
        <Route
            path='nivaliz'
            element={<ApplicationBundleUsageLayout application={Application.NIVALIZ} />}>
            {checkFeatureRoute(Feature.DASHBOARD, routeLicenseCheckResult) && (
                <Route
                    path='dashboard'
                    element={<NivalizDashboard />}
                />
            )}
            {checkFeatureRoute(Feature.INBOUND_TRANSACTION, routeLicenseCheckResult) && (
                <Route
                    path='coffins'
                    element={<Coffins />}
                />
            )}
            {checkFeatureRoute(Feature.OUTBOUND_TRANSACTION, routeLicenseCheckResult) && (
                <Route
                    path='urns'
                    element={<Urns />}
                />
            )}
            {checkFeatureRoute(Feature.TRANSACTIONS, routeLicenseCheckResult) && (
                <Route
                    path='transactions'
                    element={<NivalizTransactions />}
                />
            )}
            {checkFeatureRoute(Feature.DECEASED, routeLicenseCheckResult) && (
                <Route
                    path='deceaseds'
                    element={
                        <AsyncComponent>
                            <NivalizDeceaseds />
                        </AsyncComponent>
                    }
                />
            )}
        </Route>
    );
}
